import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  TextField,
  Popover,
} from "@mui/material";
import { DateRange } from "react-date-range";
import dayjs from "dayjs";
import toast from "react-hot-toast";

export default function Reportmodal({
  open,
  onClose,
  reportTypeData,
  lookUpList,
  hubList,
  dateFilterType,
  onGenerate,
  generatedreports,
}) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [hubs, setHubs] = useState(null);
  const [errors, setErrors] = useState({});
  const [bookingstatusVal, setBookingStatusVal] = useState(null);
  const bookingStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.fleetBookingStatus;
  delete bookingStatus?.inverted;
  

  const filteredArray = Object.entries(bookingStatus)
    .filter(([key, value]) => value === "Inquiry" || value === "Inquiry Closed")
    .map(([key, value]) => ({ key, value }));

  const [formData, setFormData] = useState({
    cityId: "",
    hubId: "",
    dateFilterType: "",
    tripStart: { startDate: null, endDate: null },
    tripEnd: { startDate: null, endDate: null },
    generated: { startDate: null, endDate: null },
    date: { startDate: null, endDate: null },
    bookingstatus: null,
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [openPicker, setOpenPicker] = useState(null);

  const isFuelHistory = reportTypeData?.title === "Fuel History Report";

  const handleDateClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setOpenPicker(type);
  };

  const validateForm = () => {
    const newErrors = {};

    if (isFuelHistory) {
      const { tripStart, tripEnd, generated } = formData;
      const noDateSelected =
        !tripStart.startDate && !tripEnd.startDate && !generated.startDate;

      if (noDateSelected) {
        newErrors.fuelHistory =
          "Please select at least one date range (Trip Start, Trip End, or Generated On).";
      }
    } else {
      if (!formData.dateFilterType) {
        newErrors.dateFilterType = "Please select a Date Filter Type.";
      }
      if (!formData.date.startDate || !formData.date.endDate) {
        newErrors.date = "Please choose a date range.";
      }
    }

    // if (!formData.cityId) newErrors.cityId = "Please select a City.";
    // if (!formData.hubId) newErrors.hubId = "Please select a Hub.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDateChange = (item, type) => {
    const startDate = item.selection.startDate;
    const endDate = item.selection.endDate;

    // Store as Date objects for the picker
    setFormData((prev) => ({
      ...prev,
      [type]: { startDate, endDate },
    }));
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleGenerate = async () => {
    if (!validateForm()) return;

    try {
      const reportEndpoints = {
        "Overall Report": {
          url: "/api/reports/overall-booking-report",
          name: "Overall",
        },
        "Overall Inquiry Report": {
          url: "/api/reports/inquiry-details-report",
          name: "Inquiry Details",
        },
        "Cancelled Booking Report": {
          url: "/api/reports/cancelled-bookings",
          name: "Cancelled Bookings",
        },
        "Booking Call Reports" : {
          url: "/api/reports/call-details",
          name: "Call Details",
        },
        "Fuel History Report": {
          url: "/api/vehicles/fuelhistory/reports",
          name: "Fuel History",
        },
        "Vehicle Revenue Report": {
          url: "/api/reports/vehicle-revenue",
          name: "Vehicle Revenue",
        },
        // "Delivery Report Agent Wise": {
        //   url: "/api/reports/delivery-agent-wise",
        //   name: "Delivery Report",
        // },
        // "Pickup Report Agent Wise": {
        //   url: "/api/reports/pickup-agent-wise",
        //   name: "Pickup Report",
        // },
        "Booking Charges": {
          url: "/api/reports/booking-charges-report",
          name: "Booking Charges",
        },
        "Customer Feedback": {
          url: "/api/reports/customer-feedback",
          name: "Customer Feedback",
        },
         "Delivery and Pickup Analytics": {
          url: "/api/reports/fleet-analytics",
          name: "Delivery and Pickup Analytics",
        },
      };

      const endpoint = reportEndpoints[reportTypeData?.title];

      if (!endpoint) {
        toast.error("Report endpoint not defined!");
        return;
      }
      

      // --- Build query params ---
      const params = [];
      const dateFields =
        reportTypeData?.title === "Fuel History Report"
          ? ["tripStart", "tripEnd", "generated"]
          : ["date"];

      const selectedDateField = dateFields.find(
        (field) => formData[field]?.startDate && formData[field]?.endDate
      );

      if (formData.dateFilterType) {
        params.push(`datefilterType=${formData.dateFilterType}`);
      }
      if (selectedDateField) {
        const startDate = dayjs(formData[selectedDateField].startDate).format(
          "YYYY-MM-DDT00:00"
        );
        const endDate = dayjs(formData[selectedDateField].endDate).format(
          "YYYY-MM-DDT23:59"
        );
        params.push(`startDate=${startDate}`);
        params.push(`endDate=${endDate}`);
      }
      if (formData.cityId) params.push(`cityId=${formData.cityId}`);
      if (formData.hubId) params.push(`hubId=${formData.hubId}`);
      if (formData.bookingstatus)
        params.push(`bookingStatus=[${formData.bookingstatus}]`);

      const url = `${apiUrl}${endpoint?.url}?${params.join("&")}`;
      const response = await toast.promise(
        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        }),
        {
          loading: "Generating report...",
          success: "Report generated successfully!",
          error: "Failed to generate report!",
        }
      );

      const data = await response.json();
      toast.dismiss();
      if (data?.statusCode !== "0100") {
        console.error("Report generation failed:", data);
        return;
      }

      const startDate = dayjs(formData[selectedDateField].startDate).format(
        "YYYY-MM-DDT00:00"
      );
      const endDate = dayjs(formData[selectedDateField].endDate).format(
        "YYYY-MM-DDT23:59"
      );

      const saveReport = async () => {
        try {
          const res = await fetch(`${apiUrl}/api/generatedreports`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `${token}`,
            },
            body: JSON.stringify({
              reportName: endpoint?.name,
              startDate,
              endDate,
              donwloadUrl: data?.entities?.Location,
              dateFilterType : formData?.dateFilterType
            }),
          });

          if (!res.ok) throw new Error(`Status ${res.status}`);
          const result = await res.json();

          if (result?.statusCode === "0100") {
            generatedreports?.();
            toast.success("Report generated successfully!");
          } else {
            console.error("Second API returned error:", result);
          }
        } catch (err) {
          console.error("Error posting generated report:", err);
        }
      };

      await saveReport();

      onClose?.();
    } catch (error) {
      console.error("Error generating report:", error);
    }
  };

  const getHubNames = async (value) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/hubs?limit=100&cityId=${value}`
      );
      const data = await response.json();
      if (data?.statusCode === "0100") setHubs(data?.entities?.rows);
    } catch (error) {
      console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    if (formData.cityId) getHubNames(formData.cityId);
  }, [formData.cityId]);

  const renderDatePopover = (type, dateValue) => (
    <Popover
      open={openPicker === type}
      anchorEl={anchorEl}
      onClose={() => setOpenPicker(null)}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <DateRange
        ranges={[
          {
            startDate: dateValue.startDate || new Date(),
            endDate: dateValue.endDate || new Date(),
            key: "selection",
          },
        ]}
        onChange={(item) => handleDateChange(item, type)}
        moveRangeOnFirstSelection={false}
        showDateDisplay={false}
        months={1}
      />
    </Popover>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-container": {
          alignItems: "center",
          justifyContent: "center",
        },
      }}
      PaperProps={{
        sx: {
          m: 0,
          maxHeight: "90vh",
        },
      }}
    >
      <DialogContent sx={{ minHeight: isFuelHistory ? 200 : 250 }}>
        <Box display="flex" flexDirection="column" gap={3}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography variant="h5">{reportTypeData?.reportType}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {reportTypeData?.summary}
              </Typography>
            </Box>
          </Box>

          <Box display="flex" flexDirection="column" gap={3}>
            <FormControl fullWidth>
              <InputLabel>Select City</InputLabel>
              <Select
                value={formData.cityId}
                label="Select City"
                onChange={(e) => handleChange("cityId", e.target.value)}
              >
                {Object.entries(lookUpList.cityData).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
              {errors.cityId && <p style={{ color: "red" }}>{errors.cityId}</p>}
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Select Hub</InputLabel>
              <Select
                value={formData.hubId}
                label="Select Hub"
                onChange={(e) => handleChange("hubId", e.target.value)}
              >
                {hubs ? (
                  hubs.map((hub) => (
                    <MenuItem key={hub.id} value={hub.id}>
                      {hub.hubName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>Select City first</MenuItem>
                )}
              </Select>
              {errors.hubId && <p style={{ color: "red" }}>{errors.hubId}</p>}
            </FormControl>

            {reportTypeData?.title === "Overall Inquiry Report" && (
              <FormControl fullWidth size="small">
                <InputLabel id="city-select-label">Booking Status</InputLabel>
                <Select
                  labelId="city-select-label"
                  id="city-select"
                  value={bookingstatusVal}
                  onChange={(e) => setBookingStatusVal(e.target.value)}
                  MenuProps={{
                    PaperProps: { sx: { maxHeight: 200 } },
                  }}
                >
                  {filteredArray &&
                    filteredArray.map((item) => (
                      <MenuItem
                        key={item.key}
                        value={item.key}
                        className="text-sm"
                      >
                        {item.value}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            )}

            {isFuelHistory ? (
              <>
                {/* Trip Start */}
                <TextField
                  fullWidth
                  label="Trip Start"
                  value={
                    formData.tripStart.startDate && formData.tripStart.endDate
                      ? `${dayjs(formData.tripStart.startDate).format(
                          "DD/MM/YYYY"
                        )} - ${dayjs(formData.tripStart.endDate).format(
                          "DD/MM/YYYY"
                        )}`
                      : ""
                  }
                  onClick={(e) => handleDateClick(e, "tripStart")}
                  InputProps={{ readOnly: true }}
                />
                {renderDatePopover("tripStart", formData.tripStart)}

                <p className="text-center">OR</p>

                {/* Trip End */}
                <TextField
                  fullWidth
                  label="Trip End"
                  value={
                    formData.tripEnd.startDate && formData.tripEnd.endDate
                      ? `${dayjs(formData.tripEnd.startDate).format(
                          "DD/MM/YYYY"
                        )} - ${dayjs(formData.tripEnd.endDate).format(
                          "DD/MM/YYYY"
                        )}`
                      : ""
                  }
                  onClick={(e) => handleDateClick(e, "tripEnd")}
                  InputProps={{ readOnly: true }}
                />
                {renderDatePopover("tripEnd", formData.tripEnd)}

                <p className="text-center">OR</p>

                {/* Generated On */}
                <TextField
                  fullWidth
                  label="Generated On"
                  value={
                    formData.generated.startDate && formData.generated.endDate
                      ? `${dayjs(formData.generated.startDate).format(
                          "DD/MM/YYYY"
                        )} - ${dayjs(formData.generated.endDate).format(
                          "DD/MM/YYYY"
                        )}`
                      : ""
                  }
                  onClick={(e) => handleDateClick(e, "generated")}
                  InputProps={{ readOnly: true }}
                />
                {renderDatePopover("generated", formData.generated)}
              </>
            ) : (
              <>
                <FormControl fullWidth>
                  <InputLabel>Select Date Filter Type</InputLabel>
                  <Select
                    value={formData.dateFilterType}
                    label="Select Date Filter Type"
                    onChange={(e) =>
                      handleChange("dateFilterType", e.target.value)
                    }
                  >
                    {Object.entries(dateFilterType).map(([key, value]) => (
                      <MenuItem key={key} value={key}>
                        {value}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.dateFilterType && (
                    <p style={{ color: "red" }}>{errors.dateFilterType}</p>
                  )}
                </FormControl>

                <TextField
                  fullWidth
                  label="Select Date Duration"
                  value={
                    formData.date.startDate && formData.date.endDate
                      ? `${dayjs(formData.date.startDate).format(
                          "DD/MM/YYYY"
                        )} - ${dayjs(formData.date.endDate).format(
                          "DD/MM/YYYY"
                        )}`
                      : ""
                  }
                  onClick={(e) => handleDateClick(e, "date")}
                  InputProps={{ readOnly: true }}
                />
                {renderDatePopover("date", formData.date)}
              </>
            )}

            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button onClick={onClose}>Cancel</Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleGenerate}
              >
                Generate Report
              </Button>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}